import { AdminAccountingScreen } from '@features/admin/ui/AdminAccountingScreen'

export function ContabilidadePage() {
  return <AdminAccountingScreen />
}
